import { getElementBoundaries } from '../BoundaryAlignment/utils';

/**
 * It accepts option and the label resolver function
 * @param option
 * @param getOptionLabel
 * @returns the option label
 */
export function optionLabel(option, getOptionLabel) {
  return option.label || getOptionLabel && getOptionLabel(option);
}
/**
 * It accepts option and the value resolver function
 * @param option
 * @param getOptionLabel
 * @returns the option value
 */

export function optionValue(option, getOptionValue) {
  var _getOptionValue;

  return (_getOptionValue = getOptionValue == null ? void 0 : getOptionValue(option)) != null ? _getOptionValue : option.value;
}
export function isGroupType(element) {
  return element.options !== undefined;
}
export function isItemSelected(item, selectedValue, getOptionValue) {
  return Array.isArray(selectedValue) ? selectedValue.some(function (selectedOption) {
    return optionValue(selectedOption, getOptionValue) === optionValue(item, getOptionValue);
  }) : selectedValue && optionValue(selectedValue, getOptionValue) === optionValue(item, getOptionValue);
}
export var calculateDropdownMaxHeight = function calculateDropdownMaxHeight(_ref) {
  var _offset$top, _offset$top2;

  var boundaryElement = _ref.boundaryElement,
      containerBoundingBox = _ref.containerBoundingBox,
      position = _ref.position,
      offset = _ref.offset;

  var _getElementBoundaries = getElementBoundaries(boundaryElement),
      bottomBoundary = _getElementBoundaries.bottomBoundary,
      topBoundary = _getElementBoundaries.topBoundary;

  var bottom = containerBoundingBox.bottom,
      top = containerBoundingBox.top;
  return position === 'bottom' ? bottomBoundary - bottom - ((_offset$top = offset == null ? void 0 : offset.top) != null ? _offset$top : 0) - 16 : top - topBoundary - ((_offset$top2 = offset == null ? void 0 : offset.top) != null ? _offset$top2 : 0) - 16;
};